import { ReactComponent as Socks } from "../assets/icons/socks.svg";
import { ReactComponent as Shorts } from "../assets/icons/shorts.svg";
import { ReactComponent as TShirt } from "../assets/icons/tshirt.svg";
import { ReactComponent as Strigner } from "../assets/icons/stringer.svg";

export const formatCartItems = (cartItems) => {
  return cartItems
    .map((item) => {
      return `Proizvod: ${item.type}\nBoja: ${item.color}\nVeličina: ${
        item.size
      }\nKoličina: ${item.quantity}\nCena: ${(
        item.price * item.quantity
      ).toFixed(2)} RSD\n\n`;
    })
    .join("");
};

export const capitalizeWords = (str) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const priceFormatter = (price) => {
  return new Intl.NumberFormat("sr-RS", {
    style: "currency",
    currency: "RSD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .format(price)
    .replace("RSD", "")
    .trim();
};

export const categoryIcons = {
  Majice: <TShirt />,
  Stringeri: <Strigner />,
  "Muscle Fit": <TShirt />,
  Šorcevi: <Shorts />,
  Čarape: <Socks />,
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day} ${month} ${year}, ${hours}:${minutes}h`;
};
